import script from "./SuperInvestorsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./SuperInvestorsPage.vue?vue&type=script&setup=true&lang=js"

import "./SuperInvestorsPage.vue?vue&type=style&index=0&id=60d8fe34&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-60d8fe34"]])

export default __exports__